<template>
  <div class="manage-screen">
    <h1 class="display-5 mb-1"><b>{{ $t('purchases.manage_screen.manage_subscription') }}</b></h1>
    <p class="text-muted mb-4">{{ $t('purchases.manage_screen.review_update_pause_or_cancel') }}</p>

    <SummaryCard :display="display" class="mb-4" />

    <div class="manage-screen__actions">
      <ActionRow
        v-if="!display.hidesBillingActions"
        :title="$t('purchases.manage_screen.update_payment_method')"
        @select="$emit('update-payment')"
      />
      <!-- Pause and resume are mutually exclusive, so only one ever shows. -->
      <ActionRow v-if="!display.hidesResumeAction" :title="$t('purchases.manage_screen.resume_my_subscription')" @select="$emit('resume')" />
      <ActionRow v-if="!display.hidesPauseAction" :title="$t('purchases.manage_screen.pause_my_subscription')" @select="$emit('pause')" />
      <!-- Nothing to cancel for a fixed-term grant (no store subscription, no card
           on file), nor for a subscription that is already cancelled and running out
           its paid period — see hidesCancelAction. The row used to be shown
           regardless: it dead-ended at a support hand-off for a grant, and for a
           cancelled sub it re-entered the cancel flow the customer had just
           finished. -->
      <ActionRow
        v-if="!display.hidesCancelAction"
        :title="$t('purchases.manage_screen.cancel_my_subscription')"
        @select="$emit('cancel')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import SummaryCard from "./SummaryCard.vue";
import ActionRow from "./ActionRow.vue";
import type { DisplayModel } from "../subscriptionLogic";

defineProps<{ display: DisplayModel }>();
defineEmits<{
  (e: "update-payment"): void;
  (e: "resume"): void;
  (e: "pause"): void;
  (e: "cancel"): void;
}>();
</script>
